import React, { useRef, useState } from "react";
import axios from "axios";
// Images
import X from "../assets/ikonice/X.svg";
import PasswordEye from "../assets/ikonice/invisible.svg";
import mail from "../assets/ikonice/mail.svg";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { setToken, setUserID } from "../store/userSlice";
// Components

import { RegisterInput } from "./RegisterInput";
import { toast } from "react-toastify";
import FacebookLogin from "react-facebook-login";
// Functions

import { useCloseModalOnEsc } from "../functions/closeModalOnEsc";
import { useFacebookLogin } from "../functions/facebookLogin";
import { toastSetup } from "../functions/toastSetup";
import { setLoginIsOpen } from "../store/loginSlice";
import { LanguageToggler } from "../components/LanguageToggler";
import { CustomSwitcher } from "../pages/profile-page/organize-event-page/Inputs";
import { useNavigate } from "react-router-dom";

const languageMap = {
  hr: {
    title: "Prijava",
    forgotPassword: "Zaboravili ste lozinku?",
    rememberMe: "Zapamti me",
    loginBtn: "Prijavi se!",
    registerBtn: "Registriraj se!",
    or: "ili",
    sendEmail: "Pošalji email za resetiranje lozinke",
    facebookBtn: "Prijavi se s Facebook-om",
    email: "Email",
    password: "Lozinka",
    noAccount: "Nemaš event.ba račun?",
    backToLogin: "Natrag na prijavu",
    successLogin: "Uspješno ste se prijavili!",
  },
  en: {
    title: "Login",
    forgotPassword: "Forgot password?",
    rememberMe: "Remember me",
    loginBtn: "Login!",
    registerBtn: "Register now !",
    or: "or",
    sendEmail: "Send email to reset password",
    facebookBtn: "Login with Facebook",
    email: "Email",
    password: "Password",
    noAccount: "Don't have an event.ba account?",
    backToLogin: "Back to login",
    successLogin: "Successfully logged in!",
  },
};

export const Login = ({ setIsRegisterOpen }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const language = useSelector((state) => state.language);
  const languageStrings = languageMap[language];
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const passwordRef = useRef(null);
  const facebookLogin = useFacebookLogin(setUserID);
  const [forgotPasswordFields, isForgotPasswordVisible] = useState(false);
  const [rememberMe, setRememberStatus] = useState(true);
  // Around modal click exit login
  const handleModalClick = (e) => {
    if (e.target.classList.contains("login-screen")) dispatch(setLoginIsOpen(false));
  };

  // Press escape key exit login

  useCloseModalOnEsc();

  // Login user
  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = e.target.elements.email.value;

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/login`, {
        password: e.target.elements.password.value,
        email,
      });

      const { id, is_banned, token } = response.data;

      if (is_banned) {
        toast.error(
          `Ovom korisniku je zabranjen pristup platformi!`,
          toastSetup("top-center", 3000)
        );
        return;
      }

      if (rememberMe) {
        localStorage.setItem("token", token);
        localStorage.setItem("userId", id);
      } else {
        sessionStorage.setItem("token", token);
        sessionStorage.setItem("userId", id);
      }

      dispatch(setUserID(id));
      dispatch(setToken(token));
      dispatch(setLoginIsOpen(false));

      toast.success(languageStrings.successLogin, toastSetup("top-center", 3000));
      // ONLY NAVIGATE TO PROFILE IF ON PASSWORD RESET ROUTE
      if (window.location.pathname.startsWith("/reset_password"))
        navigate("/profile?activeNavItem=Profil");
    } catch (error) {
      toast.error(error.response.data.message, toastSetup("top-center", 3000));
      passwordRef.current.focus();
    }
  };
  // Close login and open register
  const handleOpenRegister = (e) => {
    e.preventDefault();

    dispatch(setLoginIsOpen(false));
    setIsRegisterOpen(true);
  };

  function forgotPassword(e) {
    e.preventDefault();

    isForgotPasswordVisible(!forgotPasswordFields);
  }
  const forgotPasswordSubmit = async (e) => {
    e.preventDefault();
    const email = new FormData(e.target).get("email");

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error(languageStrings.invalidEmail, toastSetup("top-center", 3000));
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/v1/helper/request_password`,
        { email }
      );
      toast.success(response.data, toastSetup("top-center", 3000));
    } catch (error) {
      toast.error(
        error.response?.data || "Error sending password reset email",
        toastSetup("top-center", 3000)
      );
    }
  };

  return (
    <div className="login-box">
      <div className="login-screen" onClick={handleModalClick}>
        <div className="container">
          <div style={{ position: "absolute", top: "2%", left: "3%" }}>
            <LanguageToggler />
          </div>
          <button
            className="close-btn"
            onClick={() => {
              dispatch(setLoginIsOpen(false));
            }}
          >
            <img src={X} alt="" />
          </button>
          <h2>{!forgotPasswordFields ? languageStrings.title : languageStrings.forgotPassword}</h2>
          <div className="text-section" style={{ maxWidth: "340px" }}>
            <form
              onSubmit={(e) => {
                !forgotPasswordFields ? handleSubmit(e) : forgotPasswordSubmit(e);
              }}
            >
              <RegisterInput
                placeholder={languageStrings.email}
                type="email"
                icon={mail}
                name="email"
                isRequired={true}
              />
              {!forgotPasswordFields ? (
                <>
                  <RegisterInput
                    ref={passwordRef}
                    placeholder={languageStrings.password}
                    type="password"
                    icon={PasswordEye}
                    name="password"
                    cursorPointer={true}
                    isPasswordVisible={isPasswordVisible}
                    setIsPasswordVisible={setIsPasswordVisible}
                  />
                  <div className="login-btns-wrapper">
                    <button type="submit" className="login-btn">
                      {languageStrings.loginBtn}
                    </button>
                    {/* <FacebookLogin
                      textButton={languageStrings.facebookBtn}
                      appId="934444414490428"
                      autoLoad={false}
                      fields="name,email,picture"
                      callback={(fbResponse) => {
                        facebookLogin(fbResponse);
                      }}
                    /> */}
                  </div>
                </>
              ) : (
                <button className="login-btn" type="submit">
                  {languageStrings.sendEmail}
                </button>
              )}
              <div className="login-remember-wrapper">
                <a
                  onClick={(e) => {
                    forgotPassword(e);
                  }}
                  className="forgot-password"
                  href="#"
                >
                  {!forgotPasswordFields
                    ? languageStrings.forgotPassword
                    : languageStrings.backToLogin}
                </a>
                {!forgotPasswordFields ? (
                  <span className="remember-me">
                    <span>{languageStrings.rememberMe}</span>
                    <CustomSwitcher
                      id={"rememberMe"}
                      checked={rememberMe}
                      onChange={() => {
                        setRememberStatus(!rememberMe);
                      }}
                    />
                  </span>
                ) : (
                  ""
                )}
              </div>
              <p>
                {languageStrings.noAccount}
                <br />
                <button
                  className="login-btn"
                  style={{ margin: "10px auto" }}
                  onClick={handleOpenRegister}
                  type="button"
                >
                  {languageStrings.registerBtn}
                </button>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
